import React from 'react';
import { Spring, animated } from 'react-spring';

import styles from './style.css';

const JobsAndroid = () => (
  <div className={styles.jobs}>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
    >
      {style => (
        <animated.div style={style} className={styles.jobs__text__wrapper}>
          <div className={styles.jobs_hiring}>Now hiring</div>
          <div className={styles.jobs_text}>
            <span>Android</span> Developer
          </div>
        </animated.div>
      )}
    </Spring>
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }} delay={500}>
      {style => (
        <animated.div style={style} className={styles.jobs__description}>
          <p>
            Play a key role in developing Android apps for amazing clients from
            around the world; join our team in the heart of Cluj-Napoca and
            deliver for the best at the only Google Certified Agency from
            Romania.
          </p>
          <p>
            <strong>Requirements</strong> 2+ years experience building android
            apps / strong oop knowledge / attention to detail / strong
            interaction and design sense
          </p>
          <a
            className={styles.apply__button}
            href="mailto:hello@wearewip.com?Subject=Android Developer Job Application"
          >
            Apply Now
          </a>
        </animated.div>
      )}
    </Spring>
  </div>
);

export default JobsAndroid;
